import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        // 左侧菜单栏数据
        menuItems: JSON.parse(localStorage.getItem('menu'))
    },
    mutations: {
        setMenus(state, res) {
            state.menuItems = res/*[...res]*/
        }
    }
})

export default store


// WEBPACK FOOTER //
// ./src/store/index.js